export default __webpack_public_path__ + "static/media/UOB_United_Overseas_Bank_logo_logotype_symbol.f2d01b71.png";